import { render, staticRenderFns } from "./charger.vue?vue&type=template&id=f7870fd2&scoped=true&"
import script from "./charger.vue?vue&type=script&lang=js&"
export * from "./charger.vue?vue&type=script&lang=js&"
import style0 from "./charger.vue?vue&type=style&index=0&id=f7870fd2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7870fd2",
  null
  
)

export default component.exports